const NS_MAPS = 'cisview_job_';

export const SET_HISTORICAL_JOBS = `${NS_MAPS}SET_HISTORICAL_JOBS`;
export const setHistoricalJobs = historicalJobs => {
	return {
		type: SET_HISTORICAL_JOBS,
		payload: { historicalJobs }
	};
};
